module.exports = __webpack_public_path__ + "static/media/a.d946fde9.jpg";